module.exports = __webpack_public_path__ + "static/media/worldCupWinners.44fb2cc4.svg";